import { render, staticRenderFns } from "./Lvs.vue?vue&type=template&id=051d3107&scoped=true&"
import script from "@/views/Users/Student/Lvs.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Lvs.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/lvs.scss?vue&type=style&index=0&id=051d3107&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051d3107",
  null
  
)

export default component.exports